import React, { useEffect, useState, useRef } from 'react';
import './css/InsightNote.css';
import api from '../api/api';
import { useNavigate,useLocation } from 'react-router-dom';
import PptConfirmDialog from './PptConfirmDialog';
import InsightNoteContents from './InsightNoteContents';
import InsightNoteMenuBar from './InsightNoteMenuBar';


function InsightNoteContainer({ noteId, expandMargin }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [showDashboard, setShowDashboard] = useState(false); 
    const [note, setNote] = useState(null);
    const [showPptConfirmDialog, setShowPptConfirmDialog] = useState(false);
    const noteTitleRef = useRef(null);
    const noteContentsRef = useRef(null);
    const [showSavedMessage, setShowSavedMessage] = useState(false);

    useEffect(() => {
        const fetchInsightNote = async () => {
        if (!noteId) { return }
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/insight-note/${noteId}/`, {});
            setNote(response.data);
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error fetching chat list:', error);
            }
        }
    }
        fetchInsightNote(noteId);
    }, [noteId]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 's') {
                e.preventDefault(); // ブラウザのデフォルト動作を防止（ページ保存）
                saveNotebook(); // 保存処理を呼び出し
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown); // クリーンアップ
        };
    }, []);

    const saveNotebook = async () => {
        try {
            const updatedTitle = noteTitleRef.current.innerHTML;
            let updatedContents = noteContentsRef.current.innerHTML;
            const parser = new DOMParser();
            const doc = parser.parseFromString(updatedContents, 'text/html');

            // class="analysis-menu-bar" の要素を削除
            const elementsToRemove = doc.querySelectorAll('.analysis-menu-bar');
            elementsToRemove.forEach((el) => el.remove());

            // 変更後のHTMLを文字列に戻す
            updatedContents = doc.body.innerHTML;
            const data = {
                note_id: noteId,
                title: updatedTitle,
                contents: updatedContents,
            };
            await api.post(`${process.env.REACT_APP_API_URL}/chat/api/save-notebook/`, data);
            setShowSavedMessage(true);
            setTimeout(() => {
                setShowSavedMessage(false);
            }, 1000);
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error saving notebook:', error);
            }
        }
    }

    const onContinueClick = () => {
        setShowPptConfirmDialog(false);
        // パワポ作成処理
    };

    const onCancelClick = () => {
        setShowPptConfirmDialog(false);
    };

    return (
        <div className={`insight-note-contents ${expandMargin ? "md:ml-[90px]" : ""}`}>
            <InsightNoteMenuBar saveNotebook={saveNotebook} showSavedMessage={showSavedMessage}/>
            <InsightNoteContents note={note} noteTitleRef={noteTitleRef} noteContentsRef={noteContentsRef} />
            {showPptConfirmDialog ? <PptConfirmDialog onContinueClick={onContinueClick} onCancelClick={onCancelClick} /> : null}
        </div>
    );
}

export default InsightNoteContainer;
